const validation = {
	boolean_required_true: {
		invalid: "Dit veld is verplicht.",
	},
	coc: {
		invalid: "Voer een geldig KVK-nummer in.",
		same_as_tuxis: "Het KVK-nummer is hetzelfde als Tuxis.",
	},
	dadup: {
		invalid_bucket_name: "Alleen letters en cijfers zijn toegestaan.",
		invalid_display_name:
			"Alleen letters, cijfers, spaties en de karakters '-_' zijn toegestaan. De naam mag niet met een '-' of '_' beginnen",
	},
	datastore_name: {
		invalid: "Alleen letters, cijfers en de karakters '-_' zijn toegestaan.",
	},
	date: {
		invalid: "Voer een geldige datum in.",
	},
	date_of_birth: {
		too_recent: "De ingevoerde geboortedatum moet ten minste 6 jaar geleden zijn.",
	},
	debtor_code_unverified: "Debiteur niet geverifieerd",
	dns: {
		invalid: "De invoer voldoet niet aan een geldig DNS-formaat.",
	},
	domain: {
		invalid: "Voer een geldige domeinnaam in.",
	},
	email: {
		invalid: "Voer een geldig e-mailadres in.",
	},
	errors: {
		ssh_key_invalid: "De SSH-sleutel heeft een ongeldig type of beschrijving",
		unknown:
			"Er is iets misgegaan... bij aanhoudende problemen adviseren wij om contact met ons op te nemen.",
	},
	house_number: {
		invalid: "Voer een geldige huisnummer in. Het huisnummer kan alleen cijfers bevatten.",
	},
	input_free_text: {
		invalid: "Alleen letters, cijfers, spaties en de karakters'.-_+@!#$%^&*()= zijn toegestaan.",
		max_length: "Gebruik maximaal {{length}} karakters.",
		min_length: "Gebruik minimaal {{length}} karakters.",
	},
	input_number: {
		max_length: "Het getal mag niet hoger zijn dan {{length}}.",
		min_length: "Het getal mag niet lager zijn dan {{length}}.",
		only_numbers: "Uw kunt alleen cijfers gebruiken.",
	},
	input_select: {
		invalid: "Selecteer een geldige waarde",
	},
	input_text: {
		invalid: "Alleen letters, cijfers, spaties en de karakters'.-_ zijn toegestaan.",
		max_length: "Gebruik maximaal {{length}} karakters.",
		min_length: "Gebruik minimaal {{length}} karakters.",
	},
	name: {
		invalid:
			"De ingevoerde naam bevat karakters die niet toegestaan zijn. Gebruik alleen letters, spaties en de karakters , . - '",
	},
	otp: {
		invalid: "Uw 2FA-code is onjuist of verlopen! Probeer het nogmaals met een nieuwe code.",
		only_numbers: "Uw 2FA-code mag alleen uit cijfers bestaan.",
	},
	oxxa_company_name: {
		invalid:
			"De ingevoerde bedrijfsnaam voldoet niet aan de vereisten van onze derde partij. De bedrijfsnaam mag alleen bestaan uit letters, cijfers, spaties en de karakters &-().'",
	},
	password: {
		invalid: "Uw wachtwoord is onjuist!",
		invalid_current: "Uw huidige wachtwoord is onjuist!",
		no_change: "Uw nieuwe wachtwoord en uw huidige wachtwoord zijn gelijk.",
		no_match: "Bevestigingswachtwoord komt niet overeen met het wachtwoord.",
		to_weak: "Wachtwoord voldoet niet aan onze eisen",
		tooltip:
			"Gebruik ten minste 12 karakters (kleine letters, hoofdletters, nummers en speciale tekens).",
	},
	phone: {
		invalid: "Voer een geldig telefoonnummer in. Toegestaan zijn cijfers, spaties en het teken -",
		too_few_phone_number_digits:
			"Er moeten minimaal {{length}} cijfers in het telefoonnummer veld ingevoerd worden.",
		too_many_phone_number_digits:
			"Er kunnen maximaal {{length}} cijfers in het telefoonnummer veld ingevoerd worden.",
	},
	product_number_hostfact_invalid: {
		invalid:
			"Hostfact nummer voldoet niet aan formaat. Het nummer moet beginnen met een P en gevolgd worden door 3 tot 6 cijfers (P000 of P000000)",
	},
	proxmox_fingerprint: {
		invalid: "Ongeldige vingerafdruk: komt niet overeen met de Proxmox-regex.",
	},
	proxmox_host: {
		invalid: "Ongeldige hostnaam: komt niet overeen met de Proxmox-regex.",
	},
	proxmox_regex: {
		invalid: "Invoerveld komt niet overeen met de Proxmox-regex.",
	},
	proxmox_regex_free: {
		invalid: "Invoerveld komt niet overeen met de Proxmox-regex.",
	},
	proxmox_token_name: {
		invalid: "Ongeldige tokennaam: komt niet overeen met de Proxmox-regex.",
	},
	proxmox_user_name: {
		invalid: "Ongeldige gebruikersnaam: komt niet overeen met de Proxmox-regex.",
	},
	required: "Invoerveld verplicht!",
	snapshot: {
		invalid:
			'De naam van uw snapshot voldoet niet aan het juiste formaat. Gebruik letters, cijfers en/of streepjes. Gebruik geen spaties. Het woord "portal" is niet toegestaan.',
	},
	ssh_public_key: {
		invalid:
			"Uw SSH-key formaat is onjuist. Alleen formaten van de OpenSSH standaard worden ondersteund.",
	},
	username: {
		exist: "Deze gebruikersnaam is al bezet!",
		invalid:
			"Gebruikersnaam voldoet niet aan de eisen! Gebruik letters, cijfers, streepjes en/of apenstaartjes.",
	},
	vat_number: {
		invalid: "Voer een geldig BTW-nummer in.",
		same_as_tuxis: "Het BTW-nummer is hetzelfde als Tuxis.",
	},
	zip_code: {
		invalid: "Voer een geldige postcode in.",
	},
};

export default validation;
